module.exports = __webpack_public_path__ + "img/card2-bl4.15d2f815.svg";